







































































import { Component, Vue } from "vue-property-decorator";
import Container from "@/components/Container/Container.vue";
import Button from "@/components/Button/Button.vue";
import NavBar from "@/components/NavBarNew/NavBar.vue";
import { Action } from "vuex-class";
import * as types from "@/store/constants/ins_user_info_types";
import { findRouteIndex } from "@/plugins/navigation/routes";
import { goToLogin } from "@/utils/router_helper";
import { INS_RESPONSE_ERROR_MSG } from "@/api/ins/base/ins_res_const";
import Jsbridge from "@/jsbridge/index";
import { isIos } from "@/utils/lodash";
import LoginToast from "@/views/Login/LoginToast/LoginToast.vue";

@Component({
  components: {
    Container,
    Button,
    NavBar,
    LoginToast
  }
})
export default class Splash extends Vue {
  @Action(types.LOGIN_BY_FB)
  private loginByFb: any;
  private isShowLoading: boolean = false; // 是否显示转菊花
  private isShowCancelIcon: boolean = false; // 是否显示左上角关闭icon
  private interval: number = 5;
  private timer: any;
  private actionTypes = {
    CLOSE: "close",
    START_WITHOUT_LOGIN: "start_without_login",
    LOGIN_FACEBOOK: "login_facebook",
    LOGIN_INSTAGRAM: "login_instagram"
  };

  private loginToastShow: boolean = false;

  private toastTitle: string = "";
  private toastContent: string = "";
  private buttonGroup: any[] = [];
  private clickInsBtn() {
    goToLogin();
  }
  get isIOS() {
    return isIos();
  }
  private clickToInstagram(username: string) {
    if (this.isIOS) {
      Jsbridge.openBrowser(`instagram://http://instagram.com/_u/${username}`);
    } else {
      Jsbridge.openBrowser(`http://instagram.com/_u/${username}`);
    }
  }

  private showInsChallengeToast(username: string) {
    this.toastTitle = "Verification Required";
    this.toastContent = username
      ? `Dear @${username}, for safety reason, your account needs to be verified in the official Instagram app.`
      : "For safety reason, your account needs to be verified in the official Instagram app.";
    this.buttonGroup = [
      {
        clickFn: () => {
          this.loginToastShow = false;
          this.clickToInstagram(username);
        },
        content: "VERIFY NOW"
      }
    ];

    this.loginToastShow = true;
  }

  /**
   * ins error msg to resolve
   */
  private loginErrorResolve(error: any, username: string) {
    console.log("loginErrorResolve--", error);
    // 只有错误处理才会重置button装态
    const { status, error_type, message } = error;
    if (error_type === "show_toast") {
      this.$_Toast.show({
        text: message
      });
    }
    if (status === INS_RESPONSE_ERROR_MSG.CHALLENGE_REQUIRED) {
      this.showInsChallengeToast(username);
    }
  }

  private async clickFbBtn() {
    try {
      this.loginByFb().catch((err: any) => this.loginErrorResolve(err, ""));
    } catch (error) {
      // this.loginErrorResolve(error);
    }
  }

  private closeSplash(from?: string) {
    const findHomeIndex = findRouteIndex("Home");
    if (findHomeIndex > -1) {
      this.$router.go(-1);
    } else {
      this.$router.replace({
        name: "Home",
        query: {
          routerTransition: "forward"
        }
      });
    }
  }

  private mounted() {
    // 5s之后再显示关闭icon
    this.timer = setTimeout(() => {
      this.isShowCancelIcon = true;
    }, this.interval * 1000);
  }

  private deactivated() {
    clearTimeout(this.timer);
  }
}
